import { FaServer, FiBarChart, FiBriefcase, FiCalendar, FiClock, FiCreditCard, FiDatabase, FiDollarSign, FiEye, FiFile, FiFileText, FiFolder, FiList, FiMail, FiMessageCircle, FiMessageSquare, FiPackage, FiPercent, FiPhone, FiShoppingBag, FiTag, FiTruck, FiUser, FiUserCheck, FiUsers, MdOutlineShoppingCart } from '@/components/react-icons/main';

const activityModels = {
  'hris.employee': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.jobDescription || '',
    icon: FiUser
  }),
  'hris.company': (obj) => ({
    title: obj?.displayName || obj?.legalName || '',
    description: obj?.legalName || '',
    icon: FiBriefcase
  }),
  'hris.payroll': (obj) => ({
    title: `Payroll for ${obj?.employee || ''}`,
    description: `${obj?.type || ''} - ${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiDollarSign
  }),
  'hris.timesheet': (obj) => ({
    title: `Timesheet for ${obj?.employee || ''}`,
    description: `Hours worked: ${obj?.hoursWorked || ''}`,
    icon: FiClock
  }),
  'hris.bankInfo': (obj) => ({
    title: obj?.bankName || '',
    description: obj?.accountNumber || '',
    icon: FiCreditCard
  }),
  'hris.benefits': (obj) => ({
    title: obj?.name || '',
    description: obj?.type || '',
    icon: FiFileText
  }),
  'hris.dependents': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.relationship || '',
    icon: FiUser
  }),
  'hris.employeePayrollRuns': (obj) => ({
    title: `Payroll Run for ${obj?.employee || ''}`,
    description: `${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiDollarSign
  }),
  'hris.employerBenefits': (obj) => ({
    title: obj?.name || '',
    description: obj?.type || '',
    icon: FiFileText
  }),
  'hris.employments': (obj) => ({
    title: `${obj?.employee || ''} at ${obj?.company || ''}`,
    description: `${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiBriefcase
  }),
  'hris.groups': (obj) => ({
    title: obj?.name || '',
    description: obj?.type || '',
    icon: FiUsers
  }),
  'hris.locations': (obj) => ({
    title: obj?.name || '',
    description: obj?.address || '',
    icon: FiFileText
  }),
  'hris.payGroups': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiDollarSign
  }),
  'hris.payrollRuns': (obj) => ({
    title: `Payroll Run ${obj?.name || ''}`,
    description: `${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiDollarSign
  }),
  'hris.timeOff': (obj) => ({
    title: `${obj?.employee || ''} - ${obj?.type || ''}`,
    description: `${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiCalendar
  }),
  'hris.timeOffBalances': (obj) => ({
    title: `${obj?.employee || ''} - ${obj?.type || ''}`,
    description: `Balance: ${obj?.balance || ''}`,
    icon: FiClock
  }),
  'hris.timesheetEntries': (obj) => ({
    title: `Entry for ${obj?.employee || ''}`,
    description: `${obj?.date || ''} - ${obj?.hours || ''} hours`,
    icon: FiClock
  }),
  'accounting.customer': (obj) => ({
    title: obj?.name || '',
    description: obj?.emailAddress || '',
    icon: FiUsers
  }),
  'accounting.invoice': (obj) => ({
    title: `Invoice #${obj?.number || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiFileText
  }),
  'accounting.item': (obj) => ({
    title: obj?.name || '',
    description: `Unit Price: ${obj?.unitPrice || ''}`,
    icon: FiPackage
  }),
  'accounting.payment': (obj) => ({
    title: `Payment of ${obj?.totalAmount || ''}`,
    description: `${obj?.type || ''} - ${obj?.transactionDate || ''}`,
    icon: FiCreditCard
  }),
  'accounting.purchaseOrder': (obj) => ({
    title: `PO #${obj?.purchaseOrderNumber || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiShoppingBag
  }),
  'accounting.salesOrder': (obj) => ({
    title: `SO #${obj?.orderNumber || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiTruck
  }),
  'accounting.settlement': (obj) => ({
    title: `Settlement ${obj?.type || ''}`,
    description: `${obj?.totalAmount || ''} - ${obj?.depositDate || ''}`,
    icon: FiBarChart
  }),
  'accounting.transaction': (obj) => ({
    title: `Transaction #${obj?.number || ''}`,
    description: `${obj?.type || ''} - ${obj?.totalAmount || ''}`,
    icon: FiDatabase
  }),
  'accounting.vendor': (obj) => ({
    title: obj?.name || '',
    description: obj?.emailAddress || '',
    icon: FiBriefcase
  }),
  'accounting.accountingPeriod': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.startDate || ''} to ${obj?.endDate || ''}`,
    icon: FiCalendar
  }),
  'accounting.account': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.code || ''} - ${obj?.balance || ''}`,
    icon: FiDatabase
  }),
  'accounting.address': (obj) => ({
    title: `${obj?.street1 || ''}, ${obj?.city || ''}`,
    description: obj?.type || '',
    icon: FiFileText
  }),
  'accounting.attachment': (obj) => ({
    title: obj?.fileName || '',
    description: `${obj?.fileSize || ''} bytes`,
    icon: FiFile
  }),
  'accounting.balanceSheet': (obj) => ({
    title: obj?.name || '',
    description: `As of ${obj?.asOfDate || ''}`,
    icon: FiBarChart
  }),
  'accounting.bankFeedAccount': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.accountNumber || ''} - ${obj?.balance || ''}`,
    icon: FiCreditCard
  }),
  'accounting.bankFeedTransaction': (obj) => ({
    title: obj?.description || '',
    description: `${obj?.transactionDate || ''} - ${obj?.amount || ''}`,
    icon: FiDatabase
  }),
  'accounting.cashFlowStatement': (obj) => ({
    title: obj?.name || '',
    description: `Period: ${obj?.startPeriod || ''} to ${obj?.endPeriod || ''}`,
    icon: FiBarChart
  }),
  'accounting.companyInfo': (obj) => ({
    title: obj?.name || '',
    description: obj?.legalName || '',
    icon: FiBriefcase
  }),
  'accounting.contact': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'accounting.creditNote': (obj) => ({
    title: `Credit Note #${obj?.number || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiFileText
  }),
  'accounting.employee': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.employeeNumber || '',
    icon: FiUser
  }),
  'accounting.expenseReport': (obj) => ({
    title: `Expense Report #${obj?.number || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiFileText
  }),
  'accounting.expense': (obj) => ({
    title: obj?.description || '',
    description: `${obj?.transactionDate || ''} - ${obj?.amount || ''}`,
    icon: FiDollarSign
  }),
  'accounting.generalLedgerTransaction': (obj) => ({
    title: obj?.reference || '',
    description: `${obj?.transactionDate || ''} - ${obj?.totalAmount || ''}`,
    icon: FiDatabase
  }),
  'accounting.incomeStatement': (obj) => ({
    title: obj?.name || '',
    description: `Period: ${obj?.period || ''}`,
    icon: FiBarChart
  }),
  'accounting.journalEntry': (obj) => ({
    title: `Journal Entry #${obj?.number || ''}`,
    description: `${obj?.transactionDate || ''} - ${obj?.totalAmount || ''}`,
    icon: FiDatabase
  }),
  'accounting.line': (obj) => ({
    title: obj?.description || '',
    description: `${obj?.quantity || ''} x ${obj?.unitPrice || ''}`,
    icon: FiList
  }),
  'accounting.paymentMethod': (obj) => ({
    title: obj?.name || '',
    description: obj?.type || '',
    icon: FiCreditCard
  }),
  'accounting.paymentTerm': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.days || ''} days`,
    icon: FiClock
  }),
  'accounting.phoneNumber': (obj) => ({
    title: obj?.number || '',
    description: obj?.type || '',
    icon: FiPhone
  }),
  'accounting.project': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiBriefcase
  }),
  'accounting.taxRate': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.rate || ''}%`,
    icon: FiPercent
  }),
  'accounting.trackingCategory': (obj) => ({
    title: obj?.name || '',
    description: obj?.type || '',
    icon: FiTag
  }),
  'accounting.vendorCredit': (obj) => ({
    title: `Vendor Credit #${obj?.number || ''}`,
    description: `${obj?.status || ''} - ${obj?.totalAmount || ''}`,
    icon: FiFileText
  }),
  'commerce.catalog': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.productCount || ''} products`,
    icon: FiPackage
  }),
  'commerce.inventory': (obj) => ({
    title: `Inventory for ${obj?.product || ''}`,
    description: `Quantity: ${obj?.quantity || ''}`,
    icon: FiDatabase
  }),
  'commerce.product': (obj) => ({
    title: obj?.description || '',
    description: obj?.remoteId || '',
    icon: MdOutlineShoppingCart
  }),
  'commerce.productVariant': (obj) => ({
    title: obj?.description || '',
    description: obj?.remoteId || '',
    icon: MdOutlineShoppingCart
  }),
  'crm.contact': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'crm.deal': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.stage || ''} - ${obj?.amount || ''}`,
    icon: FiDollarSign
  }),
  'crm.item': (obj) => ({
    title: obj?.name || '',
    description: '',
    icon: FiPackage
  }),
  'crm.lead': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.company || '',
    icon: FiUser
  }),
  'crm.opportunity': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.stage || ''} - ${obj?.amount || ''}`,
    icon: FiDollarSign
  }),
  'crm.project': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiBriefcase
  }),
  'crm.report': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiFileText
  }),
  'crm.task': (obj) => ({
    title: obj?.subject || '',
    description: `Due: ${obj?.dueDate || ''}`,
    icon: FiClock
  }),
  'crm.user': (obj) => ({
    title: obj?.name || '',
    description: obj?.email || '',
    icon: FiUser
  }),
  'crm.engagementTypes': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiList
  }),
  'crm.engagements': (obj) => ({
    title: obj?.subject || obj?.type || '',
    description: obj?.description || '',
    icon: FiMessageCircle
  }),
  'crm.notes': (obj) => ({
    title: obj?.title || '',
    description: obj?.body || '',
    icon: FiFileText
  }),
  'crm.stages': (obj) => ({
    title: obj?.name || '',
    description: obj?.status || '',
    icon: FiTag
  }),
  'marketing.appointment': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.startTime || ''} - ${obj?.endTime || ''}`,
    icon: FiCalendar
  }),
  'marketing.campaign': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.emailsSent || ''} emails sent`,
    icon: FiMail
  }),
  'marketing.contact': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'marketing.email': (obj) => ({
    title: obj?.subject || '',
    description: obj?.fromName || '',
    icon: FiMail
  }),
  'marketing.event': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.startTime || ''} - ${obj?.endTime || ''}`,
    icon: FiCalendar
  }),
  'marketing.list': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.contactCount || ''} contacts`,
    icon: FiMail
  }),
  'marketing.message': (obj) => ({
    title: obj?.message || '',
    description: '',
    icon: FiMessageSquare
  }),
  'recruiting.application': (obj) => ({
    title: obj?.job || '',
    description: obj?.candidate || '',
    icon: FiBriefcase
  }),
  'recruiting.activity': (obj) => ({
    title: obj?.subject || obj?.activityType || '',
    description: obj?.body || '',
    icon: FiMessageCircle
  }),
  'recruiting.attachment': (obj) => ({
    title: obj?.fileName || '',
    description: obj?.attachmentType || '',
    icon: FiFileText
  }),
  'recruiting.candidate': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'recruiting.department': (obj) => ({
    title: obj?.name || '',
    description: '',
    icon: FiBriefcase
  }),
  'recruiting.eeoc': (obj) => ({
    title: obj?.candidate || '',
    description: `${obj?.race || ''} / ${obj?.gender || ''}`,
    icon: FiList
  }),
  'recruiting.interview': (obj) => ({
    title: obj?.jobInterviewStage || '',
    description: `${obj?.startAt || ''} - ${obj?.endAt || ''}`,
    icon: FiCalendar
  }),
  'recruiting.jobInterviewStage': (obj) => ({
    title: obj?.name || '',
    description: `Order: ${obj?.stageOrder || ''}`,
    icon: FiList
  }),
  'recruiting.jobPosting': (obj) => ({
    title: obj?.title || '',
    description: obj?.status || '',
    icon: FiBriefcase
  }),
  'recruiting.job': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiBriefcase
  }),
  'recruiting.offer': (obj) => ({
    title: obj?.status || '',
    description: obj?.application || '',
    icon: FiMail
  }),
  'recruiting.office': (obj) => ({
    title: obj?.name || '',
    description: obj?.location || '',
    icon: FiBriefcase
  }),
  'recruiting.rejectReason': (obj) => ({
    title: obj?.name || '',
    description: '',
    icon: FiTag
  }),
  'recruiting.scorecard': (obj) => ({
    title: obj?.overallRecommendation || '',
    description: obj?.application || '',
    icon: FiList
  }),
  'recruiting.screeningQuestion': (obj) => ({
    title: obj?.title || '',
    description: obj?.description || '',
    icon: FiList
  }),
  'recruiting.tag': (obj) => ({
    title: obj?.name || '',
    description: '',
    icon: FiTag
  }),
  'recruiting.user': (obj) => ({
    title: `${obj?.firstName || ''} ${obj?.lastName || ''}`.trim(),
    description: obj?.email || '',
    icon: FiUser
  }),
  'storage.file': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.size || ''} bytes`,
    icon: FiFile
  }),
  'storage.folder': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiFolder
  }),
  'storage.drives': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.usedSpace || ''} / ${obj?.totalSpace || ''} used`,
    icon: FaServer
  }),
  'storage.groups': (obj) => ({
    title: obj?.name || '',
    description: `${obj?.memberCount || ''} members`,
    icon: FiUsers
  }),
  'storage.users': (obj) => ({
    title: obj?.name || '',
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'dataExtraction.document': (obj) => ({
    title: obj?.title || obj?.sourceUrl || '',
    description: obj?.sourceUrl || '',
    icon: FiFileText
  }),
  'teamMessaging.message': (obj) => ({
    title: obj?.message || '',
    description: `Message sent: ${obj?.message}`,
    icon: FiMessageSquare
  }),
  'ticketing.collection': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiList
  }),
  'ticketing.comment': (obj) => ({
    title: obj?.body || '',
    description: obj?.contact || '',
    icon: FiMessageCircle
  }),
  'ticketing.contact': (obj) => ({
    title: obj?.name || '',
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'ticketing.ticket': (obj) => ({
    title: obj?.name || '',
    description: obj?.status || '',
    icon: FiTag
  }),
  'ticketing.accounts': (obj) => ({
    title: obj?.name || '',
    description: (obj?.domains && obj.domains.join(', ')) || '',
    icon: FiUsers
  }),
  'ticketing.attachments': (obj) => ({
    title: obj?.fileName || '',
    description: obj?.contentType || '',
    icon: FiFileText
  }),
  'ticketing.roles': (obj) => ({
    title: obj?.name || '',
    description: (obj?.ticketActions && obj.ticketActions.join(', ')) || '',
    icon: FiUserCheck
  }),
  'ticketing.tags': (obj) => ({
    title: obj?.name || '',
    description: '',
    icon: FiTag
  }),
  'ticketing.teams': (obj) => ({
    title: obj?.name || '',
    description: obj?.description || '',
    icon: FiUsers
  }),
  'ticketing.users': (obj) => ({
    title: obj?.name || '',
    description: obj?.emailAddress || '',
    icon: FiUser
  }),
  'ticketing.viewers': (obj) => ({
    title: obj?.user || '',
    description: obj?.team || '',
    icon: FiEye
  })
};

export default activityModels;
